module.exports = __webpack_public_path__ + "static/media/three.ca1e4a7d.svg";